import React, { useEffect, useState } from "react";
import { selectCurrent } from '../redux/theme/selectors'
import { selectCurrent as selectSettings } from "../redux/settings/selectors";
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { MultiSelect } from "react-multi-select-component";
import { settings } from "../redux/settings/actions";
import GoogleSearchMapNew from "../common/components/google-map-search-new";
import { useSelector } from "react-redux";
import { RadioGroup } from "@headlessui/react";
import { selectCmsSettingsListItems } from "../redux/cmsSettings/selector";
import { selectListItems as selectLibraryListItems } from "../redux/library/selector";
import { selectQuotesCreatedItem as selectCreateQuoteDetails } from "../redux/quotes/selector";
import { selectOrdersCreatedItem as selectCreateOrderDetails } from "../redux/orders/selector";
import { selectUpdatedItem as selectInitiateRazorpayDetails } from "../redux/razporpay/selector";
import _ from "lodash";
import { orders } from "../redux/orders/action";
import { getFormattedDate } from "../common/services/date.service";
import moment from "moment";
import { quotes } from "../redux/quotes/action";
import { razorpay } from "../redux/razporpay/action";
import storePersist from "../redux/storePersist";
import { addPayment } from "../redux/addPayment/action";
import { shippingTypes } from "../redux/shippingTypes/action";
import { selectShippingTypesListItems } from "../redux/shippingTypes/selector";
import { selectLeadsCreatedItem, selectLeadsListItems } from "../redux/leads/selector";
import { selectCategoriesListItems } from "../redux/categories/selector";
import { categories } from "../redux/categories/action";
import { paymentMethods } from "../redux/payment-methods/action";
import { channel } from "../redux/channel/action";
import { selectPaymentMethodsQueryItems } from "../redux/payment-methods/selector";
import { selectOrganizationUnitsListItems } from "../redux/organizationUnits/selector";
import queryString from "query-string";
import CryptoJS from 'crypto-js';
import { productTypes } from "../redux/product-types/action";
import { selectProductTypesListItems } from "../redux/product-types/selector";
import { subCategories } from "../redux/sub-categories/action";
import { selectSubCategoriesListItems } from "../redux/sub-categories/selector";
import { leads } from "../redux/leads/action";
import { InputContainer } from "../common/components/form/input/containers/input.container";
import { selectCustomersListItems } from "../redux/customers/selector";
import { customers } from "../redux/customers/action";
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import { products } from "../redux/products/action";
import { selectProductsListItems } from "../redux/products/selector";
declare let Razorpay: any;
let currentChange: any = {};
export default function GetQuote() {
	interface ISteps {
		CategoryName: string;
		ItemName: string
		PackageType: string
		Weight: string
		Width: string
		Height: string
		Length: string
		AdditionalInfo: string
		NumberOfItems: number
	}
	// interface IPackage {
	// 	package: string
	// }
	const dispatch = useAppDispatch();
	const { getQuote } = useAppSelector(selectCurrent)
	const result = useSelector(selectCurrent)
	const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
	const [color, setColor] = useState('universal')
	const defaultSetting = useSelector(selectSettings)
	const { header, footer, visible, sidebar, theme, primary, secondary } = defaultSetting
	const leadDetails = useSelector(selectLeadsListItems)
	const quoteDetails = useSelector(selectCreateQuoteDetails)
	const paymentSettings = useSelector(selectCmsSettingsListItems)
	const leadCreateData = useSelector(selectLeadsCreatedItem)
	const shippingTypesDetails = useSelector(selectShippingTypesListItems)
	const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
	const [quoteData, SetQuoteData] = useState<any>({});
	const [isQuotes, setIsQuotes] = useState<boolean>(false)
	const [razorpaySettings, setRazorpaySettings] = useState<any>([])
	const [leadValues, setLeadValues] = useState<any>()
	const [isLead, setIsLead] = useState<boolean>(false)
	const productListData = useSelector(selectProductsListItems)
	const handleChange: any = (event: any, field: string) => {
		setLeadValues({ ...leadValues, [field]: event })
	}
	const handleInnerFormChange: any = (event: any, field: string) => {
		SetQuoteData({ ...quoteData, [field]: event });
	};

	const [isOrderPlaced, setIsOrderPlaced] = useState<any>(false);
	const [isPaymentAdded, setIsPaymentAdded] = useState<any>(false);

	const customerListData = useSelector(selectCustomersListItems)
	var storeId = storePersist?.get("queryByStore")?.current[0]?.StoreId;
	const [paymentGateway, setPaymentGateway] = useState<any>([]);
	const categoryListItems = useSelector(selectCategoriesListItems)
	const subCategoryListItems = useSelector(selectSubCategoriesListItems)
	const orderDetails = useSelector(selectCreateOrderDetails)
	const [orderId, setOrderId] = useState<any>()
	const productTypesitemsData = useSelector(selectProductTypesListItems)
	const organizationUnitLists = useSelector(selectOrganizationUnitsListItems)
	const [generateIds, setGenerateIds] = useState<any>([]);
	var tenantId = storePersist.get('guestTokenMetadata')?.current?.result?.TokenMetadata?.TenantId
	var salesChannelId = storePersist?.get("queryByStore")?.current[0]?.SalesChannelId;
	var rapCustomerId = storePersist?.get("userProfile")?.current?.items[0]?.Message?.Id;
	const MODE = 'test';

	useEffect(() => {
		setColor(theme)
	}, [theme]);
	const [count, setCount] = useState(1)
	const [searchedLocation, setSearchedLocation] = useState<any>({
		name: result?.searchedLocation?.name || '',
		lat: result?.searchedLocation?.lat || '',
		lng: result?.searchedLocation?.lng || '',
		pincode: result?.searchedLocation?.pincode || '',
		description: result?.searchedLocation?.Description || '',
	});
	const [dropLocations, setDropLocation] = useState<any>({
		name: result?.searchedToLocation?.name || '',
		lat: result?.searchedToLocation?.lat || '',
		lng: result?.searchedToLocation?.lng || '',
		pincode: result?.searchedToLocation?.pincode || '',
		description: result?.searchedToLocation?.Description || '',
	});
	const [selectedInput, setSelectedInput] = useState("");

	const [productItems, setProductItems] = useState<any>([]);
	const parentCategories = categoryListItems?.result?.items.filter(
		(subCategoryData: any) => subCategoryData.IsSubCategory === false
	)

	let filterCustomer = _.find(customerListData.result.items, ['Id', leadValues?.CustomerId]);
	const handleCustomerSearch = async ({ event }: any) => {
		await dispatch(customers.resetAction({ actionType: 'list' }))
		await dispatch(customers.list({
			url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/customers/list`, entity: 'categories', jsonData: {
				"Filters": [
					{
						"FieldName": "AccountName",
						"FilterOperatorId": 6,
						"FieldValue": event,
						"FieldType": "text"
					}
				],
			}
		}))
	}
	const handleInnerbasicFormChange: any = (event: any, field: string) => {
		setProductItems({ ...productItems, [field]: event })
	}
	useEffect(() => {
		dispatch(subCategories.resetAction({ actionType: 'list' }))
		if (productItems?.CategoryName) {
			const CategoryName = categoryListItems?.result?.items.find(
				(item: any) => item.ParentCategoryName == productItems?.CategoryName
			);
			if (CategoryName?.ParentCategoryId) {
				dispatch(subCategories.list({
					url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,
					entity: 'categories',
					jsonData: {
						"Filters": [
							{
								"FieldName": "ParentCategoryId",
								"FilterOperatorId": 1,
								"FieldValue": CategoryName?.ParentCategoryId,
								"FieldType": "number"
							}
						],
					}
				}))
			}

		}

	}, [productItems?.CategoryName]);
	const items = [
		{
			name: 'Cash',
			description: 'Cash on delivery',
			value: 10,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForCOD || true,
		},
		{
			name: 'Online',
			description: 'Payment gateway',
			value: 20,
			checked: 'checked',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForOnline,
		},
		{
			name: 'Wallet',
			description: 'Wallet',
			value: 40,
			checked: '',
			show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForWallet,
		},
	];
	const [selected, setSelected] = useState(items[0].value);


	const tutorialSteps = [
		{
			id: 1,
			title: 'Instant Data',
			subTitle: 'List of Items',
			component: (
				<>
					<div className="w-full p-5 shadow rounded-xl">
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">

							{/* Register Checkbox */}
							<div className="w-full text-xs flex flex-row justify-start items-center">
								<input
									type="checkbox"
									name="from"
									className="px-2 bg-primary text-xs px-3"
									onChange={(event) => {
										handleChange(event.target.checked, 'IsExistingUser');
									}}
									checked={leadValues?.IsExistingUser}
								/>
								<div className="mx-2">Are You Already Registered?</div>
							</div>

							{/* Conditional Form Rendering */}
							{!leadValues?.IsExistingUser ? (
								<>
									{/* Full Name */}
									<div className="w-full pb-5">
										<label className="block text-xs font-light">Full Name</label>
										<div className="w-full border border-black border-opacity-50 text-xs rounded">
											<input
												type="text"
												name={"Name"}
												className="w-full rounded bg-opacity-0 text-xs py-2 px-2"
												onChange={(event) => {
													handleChange(event.target.value, 'Name');
												}}
												value={leadValues?.Name}
											/>
										</div>
									</div>

									{/* Phone Number */}
									<div className="w-full pb-5">
										<label className="block text-xs font-light">Phone Number</label>
										<div className="w-full border border-black border-opacity-50 text-xs rounded">
											<input
												type="number"
												name={"PhoneNumber"}
												className="w-full rounded bg-opacity-0 text-xs py-2 px-2"
												onChange={(event) => {
													handleChange(event.target.value, 'PhoneNumber');
												}}
												value={leadValues?.PhoneNumber}
											/>
										</div>
									</div>

									{/* Email */}
									<div className="w-full pb-5">
										<label className="block text-xs font-light">Email</label>
										<div className="w-full border border-black border-opacity-50 text-xs rounded">
											<input
												type="email"
												name={"Email"}
												placeholder="Email"
												className="w-full rounded bg-opacity-0 text-xs py-2 px-2"
												onChange={(event) => {
													handleChange(event.target.value, 'Email');
												}}
												value={leadValues?.Email}
											/>
										</div>
									</div>

									{/* Product Type */}
									<div className="w-full pb-5">
										<label className="block text-xs font-light">Choose Product</label>
										<div className="w-full border border-black border-opacity-50 text-xs rounded">
											<select
												className="w-full rounded bg-opacity-0 text-xs py-2"
												id="default"
												onChange={(event) => {
													handleChange(event.target.value, 'MobilityProdcutId');
												}}
												value={leadValues?.MobilityProdcutId}
											>
												<option>--Select--</option>
												{productListData?.result?.items?.map((item, index) => (
													<option value={item.Id} key={index}>
														{item.Name}
													</option>
												))}
											</select>
										</div>
									</div>

									{/* Description */}
									<div className="w-full pb-5 col-span-full">
										<label className="block text-xs font-light">Description</label>
										<div className="w-full rounded bg-opacity-0 text-xs py-2 px-2">
											<textarea
												name="Description"
												placeholder="Description"
												className="w-full py-3 px-3 border-b-2 border-black text-base"
												onChange={(event) => {
													handleChange(event.target.value, 'Description');
												}}
												value={leadValues?.Description}
											/>
										</div>
									</div>
								</>
							) : (
								<>
									{/* Existing User: Email */}
									{leadValues?.IsExistingUser && (
										<div className="w-full pb-5">
											<label className="block text-xs font-light">Customer Name</label>
											<InputContainer
												className="w-full rounded border border-black border-opacity-50 text-xs py-2"
												labelField="RAPCustomerName"
												placeholder="Description"
												isLoading={customerListData?.isLoading}
												list={customerListData?.result?.items}
												onTypeahead={(event: any) => handleCustomerSearch({ event })}
												onValueChange={(event: any) => {
													handleChange(event, 'CustomerId');
												}}
												type="typeahead"
												value={leadValues?.CustomerId}
												valueField="Id"
											/>
										</div>
									)}
									{/* Email */}
									<div className="w-full pb-5">
										<label className="block text-xs font-light">Email</label>
										<div className="w-full border border-black border-opacity-50 text-xs rounded">
											<input
												type="email"
												name={"Email"}
												placeholder="Email"
												className="w-full rounded bg-opacity-0 text-xs py-2 px-2"
												onChange={(event) => {
													handleChange(event.target.value, 'Email');
												}}
												value={leadValues?.Email}
											/>
										</div>
									</div>
									{/* Product Type */}
									<div className="w-full pb-5">
										<label className="block text-xs font-light">Choose Product</label>
										<div className="w-full border border-black border-opacity-50 text-xs rounded">
											<select
												className="w-full rounded bg-opacity-0 text-xs py-2"
												id="default"
												onChange={(event) => {
													handleChange(event.target.value, 'MobilityProdcutId');
												}}
												value={leadValues?.MobilityProdcutId}
											>
												<option>--Select--</option>
												{productListData?.result?.items?.map((item, index) => (
													<option value={item.Id} key={index}>
														{item.Name}
													</option>
												))}
											</select>
										</div>
									</div>


									{/* Description */}
									<div className="w-full pb-5 col-span-full">
										<label className="block text-xs font-light">Description</label>
										<div className="w-full rounded bg-opacity-0 text-xs py-2 px-2">
											<textarea
												name="Description"
												placeholder="Description"
												className="w-full py-3 px-3 border-b-2 border-black text-base"
												onChange={(event) => {
													handleChange(event.target.value, 'Description');
												}}
												value={leadValues?.Description}
											/>
										</div>
									</div>
								</>
							)}
						</div>
					</div>
				</>
			),
			display: true,
		},
		{
			id: 2,
			title: 'Select Items',
			subTitle: 'List of Items',
			component: (


				<>

					<div className="w-full p-5 shadow rounded-xl">
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
							{/* Product Type */}
							<div className="w-full pb-5">
								<label className="block text-xs font-light">Product Type</label>
								<div className="w-full border border-black border-opacity-50 text-xs rounded">
									<select
										className={`w-full rounded bg-opacity-0 text-xs py-2`}
										id="default"
										onChange={(event: any) => {
											handleInnerbasicFormChange(event.target.value, 'ProductTypeName');
										}}
										value={productItems?.ProductTypeName}
									>
										<option>--Select--</option>
										{productTypesitemsData?.result?.items?.map((item: any, index: any) => (
											<option value={item.Nmae} key={index}>{item.Name}</option>
										))}
									</select>
								</div>
							</div>

							{/* Category */}
							<div className="w-full pb-5">
								<label className="block text-xs font-light">Category</label>
								<div className="w-full border border-black border-opacity-50 text-xs rounded">
									<select
										className={`w-full rounded bg-opacity-0 text-xs py-2`}
										id="default"
										onChange={(event: any) => {
											handleInnerbasicFormChange(event.target.value, 'CategoryName');
										}}
										value={productItems?.CategoryName}
									>
										<option>--Select--</option>
										{parentCategories?.map((item: any, index: any) => (
											<option value={item.Name} key={index}>{item.Name}</option>
										))}
									</select>
								</div>
							</div>

							{/* SubCategory Name */}
							{productItems?.CategoryName && (
								<>
									{subCategoryListItems?.isLoading ? <div className="w-full pb-5">
										<label className="block text-xs font-light">SubCategory Name</label>
										<label className="block text-sm font-normal">Loading...</label>

									</div> : (subCategoryListItems?.result?.items.length > 0 ? <div className="w-full pb-5">
										<label className="block text-xs font-light">SubCategory Name</label>
										<select
											className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
											id="default"
											onChange={(event: any) => {
												handleInnerbasicFormChange(event.target.value, 'SubCategoryName');
											}}
											value={productItems?.SubCategoryName}
										>
											<option>--Select--</option>
											{subCategoryListItems?.result?.items?.map((item: any, index: any) => (
												<option value={item.Name} key={index}>{item.Name}</option>
											))}
										</select>

									</div> : <div className="w-full pb-5">
										<label className="block text-xs font-light">No SubCategory Available</label>


									</div>
									)}
								</>)}

							{/* Vehicle Number */}
							<div className="w-full pb-5">
								<label className="block text-xs font-light">Vehicle Number</label>
								<div className="w-full border border-black border-opacity-50 text-xs rounded">
									<input
										type="text"
										name="value"
										className={`w-full rounded bg-opacity-0 text-xs py-2 px-2`}
										onChange={(event: any) => {
											handleInnerbasicFormChange(event.target.value, 'VehicleNumber');
										}}
										value={productItems?.VehicleNumber}
									/>
								</div>
							</div>

							{/* Vehicle Chassis Number */}
							<div className="w-full pb-5">
								<label className="block text-xs font-light">Vehicle Chassis Number</label>
								<div className="w-full border border-black border-opacity-50 text-xs rounded">
									<input
										type="text"
										name="value"
										className={`w-full rounded bg-opacity-0 text-xs py-2 px-2`}
										onChange={(event: any) => {
											handleInnerbasicFormChange(event.target.value, 'VehicleChassisNumber');
										}}
										value={productItems?.VehicleChassisNumber}
									/>
								</div>
							</div>

							{/* Vehicle Brand */}
							<div className="w-full pb-5">
								<label className="block text-xs font-light">Vehicle Brand</label>
								<div className="w-full border border-black border-opacity-50 text-xs rounded">
									<input
										type="text"
										name="value"
										className={`w-full rounded bg-opacity-0 text-xs py-2 px-2`}
										onChange={(event: any) => {
											handleInnerbasicFormChange(event.target.value, 'VehicleBrand');
										}}
										value={productItems?.VehicleBrand}
									/>
								</div>
							</div>

							{/* Vehicle Model */}
							<div className="w-full pb-5">
								<label className="block text-xs font-light">Vehicle Model</label>
								<div className="w-full border border-black border-opacity-50 text-xs rounded">
									<input
										type="text"
										name="value"
										className={`w-full rounded bg-opacity-0 text-xs py-2 px-2`}
										onChange={(event: any) => {
											handleInnerbasicFormChange(event.target.value, 'VehicleModel');
										}}
										value={productItems?.VehicleModel}
									/>
								</div>
							</div>
							{/* Vehicle year */}
							<div className="w-full pb-5">
								<label className="block text-xs font-light">Vehicle Year</label>
								<div className="w-full border border-black border-opacity-50 text-xs rounded">
									<input
										type="text"
										name="value"
										className={`w-full rounded bg-opacity-0 text-xs py-2 px-2`}
										onChange={(event: any) => {
											handleInnerbasicFormChange(event.target.value, 'VehicleYear');
										}}
										value={productItems?.VehicleYear}
									/>
								</div>
							</div>

						</div>
					</div>


				</>




			),
			display: true,
		},
		{
			id: 3,
			title: 'Location Details',
			subTitle: 'Pickup Details',
			component: (

				<div className="w-full flex flex-col">
					<div className="flex flex-col">

						<div className=" w-full p-1">
							<label
								className="block text-xs font-bold mb-1 uppercase"
								htmlFor="grid-password">
								PickUp Details
							</label>
							<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
								<GoogleSearchMapNew
									setLocation={setSearchedLocation}
									location={searchedLocation}
									placeholder="Pickup Address" />
							</div>
						</div>
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
							<div className="w-full">
								<label className="block text-xs font-bold mb-1 ">Name <span className="text-red-500">*</span></label>
								<input
									type="text"
									name="pickupName"
									className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
									onChange={(event: any) => handleInnerFormChange(event.target.value, 'pickupName')}
									value={quoteData?.pickupName}
								/>
							</div>
							<div className="w-full">
								<label className="block text-xs font-bold mb-1 ">Phone Number <span className="text-red-500">*</span></label>
								<input
									type="text"
									maxLength={10}
									name="pickupPhoneNumber"
									className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
									onChange={(event: any) => handleInnerFormChange(event.target.value.replace(/\D/g, ''), 'pickupPhoneNumber')}
									value={quoteData?.pickupPhoneNumber}
								/>
							</div>
						</div>
						<div className=" w-full p-1">
							<label
								className="block text-xs font-bold mb-1 uppercase"
								htmlFor="grid-password">
								Pickup Details Address Additional Info
							</label>
							<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
								<input
									type="type"
									name={"from"}
									placeholder=""
									className={`w-full py-2  bg-opacity-0 text-xs px-3 teritary-${color}`}
									onChange={(event: any) => {
										handleInnerFormChange(
											event.target.value,
											'startBuilding'
										)
									}}
									value={quoteData?.startBuilding}
								/>
							</div>
						</div>
					</div>
					<div className="flex flex-col">

						<div className=" w-full p-1">
							<label
								className="block text-xs font-bold mb-1 uppercase"
								htmlFor="grid-password">
								Drop Details
							</label>
							<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
								<GoogleSearchMapNew
									setLocation={setDropLocation}
									location={dropLocations}
									placeholder="Drop Details" />
							</div>
						</div>
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
							<div className="w-full">
								<label className="block text-xs font-bold mb-1 ">Name <span className="text-red-500">*</span></label>
								<input
									type="text"
									name="dropName"
									className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
									onChange={(event: any) => handleInnerFormChange(event.target.value, 'dropName')}
									value={quoteData?.dropName}
								/>
							</div>
							<div className="w-full">
								<label className="block text-xs font-bold mb-1 ">Phone Number <span className="text-red-500">*</span></label>
								<input
									type="text"
									maxLength={10}
									name="dropPhoneNumber"
									className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
									onChange={(event: any) => handleInnerFormChange(event.target.value.replace(/\D/g, ''), 'dropPhoneNumber')}
									value={quoteData?.dropPhoneNumber}
								/>
							</div>
						</div>
						<div className=" w-full p-1">
							<label
								className="block text-xs font-bold mb-1 uppercase"
								htmlFor="grid-password">
								Drop Details Address Additional Info
							</label>
							<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
								<input
									type="text"
									name={"from"}
									placeholder=""
									className={`w-full py-2  bg-opacity-0 text-xs px-3 teritary-${color}`}
									onChange={(event: any) => {
										handleInnerFormChange(
											event.target.value,
											'endBuilding'
										)
									}}
									value={quoteData?.endBuilding}
								/>
							</div>
						</div>
					</div>

				</div>

			),
			display: true,
		},
		{
			id: 4,
			title: 'Delivery Schedule',
			subTitle: 'Delivery Schedule',
			component: (
				<div className="flex flex-col">
					<div className=" w-full p-1">
						<label
							className="block text-xs font-bold mb-1 uppercase"
							htmlFor="grid-password">
							Delivery Schedule
						</label>
						<div className="bg-white border-x border-y border-black border-opacity-50 text-xs rounded" >
							<input
								required
								id="datetime"
								type="datetime-local"
								name="scheduleDate"
								min={
									new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
										.toISOString()
										.slice(0, 16)
								}
								onClick={(event) => {
									const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
									input.showPicker(); // Now you can call showPicker() safely
								}}
								className={"w-full py-2 px-3 border border-black/50 text-xs rounded bg-gray-50"}
								onChange={(e) => handleInnerFormChange(e.target.value, 'date')}
								value={quoteData?.date}
							/>
						</div>
					</div>
				</div>
			),
			display: true,
		},
		{
			id: 5,
			title: 'Confirm Booking',
			subTitle: 'Order Summary',
			component: (
				<div className="w-full">
					<div className="mb-6 ">
						<h1> Order  Summary Details</h1>

					</div>
					<table className="w-full  font-semibold text-sm lg:text-base">
						<tfoot>
							<tr className={`secondary-${color}`}>
								<td className="p-4 italic">{"Amount Quoted "}</td>
								<td className="p-4"> {quoteDetails?.result?.Records[0]?.quote?.breakup[0]?.price?.value}</td>
							</tr>
							<tr className={`secondary-${color}`}>
								<td className="p-4 italic">{"Relocation Date"}</td>
								<td className="p-4">
									{quoteData?.date ? getFormattedDate(quoteData?.date) : moment().format('YYYY-MM-DD h:mm:ss a')}
									{/* <span className="text-[13px] font-normal ps-1.5 inline-block">
                via Flat rate
              </span> */}
								</td>
							</tr>
							<tr className={`secondary-${color}`}>
								<td className="p-4 italic">{"Service Type"}</td>
								<td className="p-4">{"Standard"}</td>
							</tr>
							<tr className={`secondary-${color}`}>
								<td className="p-4 italic">{"No of items added"}</td>
								<td className="p-4">{quoteDetails?.result?.Records[0]?.items?.length }</td>
							</tr>


							{/* <tr className="odd:bg-skin-secondary">
            <td className="p-4 italic">{useLocale('common', 'text-note')}:</td>
            <td className="p-4">{useLocale('common', 'text-new-order')}</td>
          </tr> */}
						</tfoot>
					</table>
				</div>
			),
			display: true,
		},
		{
			id: 6,
			title: 'Payment Option',
			subTitle: 'Select payment slot',
			component: (
				<div className="block">
					<div className="mt-2">
						<RadioGroup
							value={selected}
							onChange={setSelected}
							className="md:grid md:grid-cols-2 md:gap-5 auto-rows-auto space-y-4 md:space-y-0"
						>
							{items?.length > 0 ? (
								items?.map(
									(item: any, index: any) =>
										item.show && (
											<RadioGroup.Option
												key={index}
												value={item.value}
												className={({ checked }) =>
													`${checked ? ' border-blue-800' : ' border-blue-400'}
                    border-2 relative shadow-md focus:outline-none rounded-md p-5 block cursor-pointer min-h-[112px] h-full group address__box`
												}
											>
												<RadioGroup.Label
													as="h3"
													className=" font-semibold mb-2 -mt-1"
												>
													{item?.name}
												</RadioGroup.Label>
												<RadioGroup.Description
													as="div"
													className="  leading-6"
												>
													{item?.description}
												</RadioGroup.Description>
											</RadioGroup.Option>
										),
								)
							) : (
								<div className="border-2 border-skin-base rounded font-semibold p-5 px-10 text-skin-ouprimary flex justify-start items-center min-h-[112px] h-full">
									No payment option found
								</div>
							)}
						</RadioGroup>
					</div>
				</div>
			),
			display: true,
		},
	];
	const [activeStep, setActiveStep] = useState(0);
	const maxSteps = tutorialSteps.length;
	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};
	const handleClose = () => {
		SetQuoteData({})
		setProductItems([])
		dispatch(settings.set({ getQuote: 'close' }))
		setCount(1)
		setActiveStep(0)
		setSearchedLocation({
			name: '',
			lat: '',
			lng: '',
			pincode: '',
			description: ''
		})
		setDropLocation({
			name: '',
			lat: '',
			lng: '',
			pincode: '',
			description: ''
		})

	}



	useEffect(() => {

	}, [count, selectedInput]);
	useEffect(() => {

	}, [selected])
	const generateUniqueId = () => {
		const randomPart = Math.random().toString(36).substr(2, 9); // Random part
		const timestampPart = Date.now().toString(36); // Timestamp part
		return `${randomPart}-${timestampPart}`;
	};
	const generateIdValue = () => {
		const newItem = {
			transaction_id: generateUniqueId(),
			message_id: generateUniqueId(),
			fulfillment_id: generateUniqueId(),
			item_id: generateUniqueId(),
			order_id: generateUniqueId(),
		};
		setGenerateIds(newItem);
	};
	useEffect(() => {
		setRazorpaySettings(paymentMethodQuery?.result?.items?.RazorPayConfiguration);
		// setRazorpaySettings([
		// 	{
		// 		"Id": 3,
		// 		"RazorPayConfiguration": {
		// 			"RazorPayConfigurationPId": "97-ORD-JBN-2",
		// 			"StoreId": 183,
		// 			"GatewayName": "RazorPay",
		// 			"GatewayKey": "rzp_test_iS2R7go2pSvdA3",
		// 			"GatewaySecret": "px5DE484H7meoTSsSHepRx14",
		// 			"RazorPay": {
		// 				"GatewayName": "RazorPay",
		// 				"GatewayKey": "00000000",
		// 				"GatewaySecret": "00000000",
		// 				"IsActive": false
		// 			},
		// 			"CCAvenue": {
		// 				"GatewayName": "CCAvenue",
		// 				"WorkingKey": "351280CC07CE5C96BD46FCC3570879B4",
		// 				"MerchantId": "3096301",
		// 				"AccessCode": "AVCN05KL42CE88NCEC",
		// 				"IsActive": true
		// 			},
		// 			"PhonePe": {
		// 				"GatewayName": "PhonePe",
		// 				"SaltKey": "00000000",
		// 				"MerchantId": "00000000",
		// 				"SaltIndex": "00000000",
		// 				"IsActive": false
		// 			},
		// 			"IsActive": true,
		// 			"CreatedOnUtc": "2022-05-12T13:03:39.633",
		// 			"CreatedById": 231,
		// 			"ModifiedOnUtc": "2022-05-12T13:03:39.633",
		// 			"ModifiedById": 231
		// 		}
		// 	}
		// ])
	}, [paymentMethodQuery]);
	useEffect(() => {
		const gateways: any = []
		if (razorpaySettings?.RazorPay?.IsActive) {
			gateways.push({ Id: 10, title: 'Razorpay', detail: 'Razorpay' })
		}
		if (razorpaySettings?.CCAvenue?.IsActive) {
			//console.log('razorpaySettings?.CCAvenue?.GatewayKey ', razorpaySettings?.CCAvenue?.GatewayKey)
			gateways.push({ Id: 20, title: 'CC Avenue', detail: 'CC Avenue' })
		}
		if (razorpaySettings?.PhonePe?.IsActive) {
			gateways.push({ Id: 30, title: 'PhonePe', detail: 'PhonePe' })
		}
		setPaymentGateway(gateways);
	}, [razorpaySettings]);
	// Step 1: Submit Lead
	const handleSubmit = async (event: any) => {
		event?.preventDefault()
		if (
			!leadValues?.Email ||
			!leadValues?.MobilityProdcutId
		) {
			toast.error("All fields are required. Please fill in all the details.");
			return; // Stop further execution if validation fails
		}
		try {
			await setIsButtonLoading(true)
			await dispatch(settings.set({
				quoteData: leadValues,

			}))
			await dispatch(leads.resetAction({ actionType: 'create' }))
			await dispatch(leads.create({
				url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/leads`, entity: 'leadCreate', jsonData: {
					"Records": [
						{
							LeadInfo: {
								Name: leadValues?.IsExistingUser ? filterCustomer?.RAPCustomerName : leadValues?.Name,
								Description: leadValues?.Description || '',
								Email: leadValues?.Email || null,
								PhoneNumber: leadValues?.IsExistingUser ? filterCustomer?.PhoneNumber : leadValues?.PhoneNumber,
								MobilityProductId: leadValues?.MobilityProdcutId, // or rename key properly below
								IsVariant: false,
								MobilityVariantId: 0,
								IsExistingUser: leadValues?.IsExistingUser || false
							}

						}
					]
				}
			}))

			// dispatch(settings.set({
			// 	quoteData: leadValues,

			// }))
			await setIsLead(true)
			await setIsButtonLoading(false)
		} catch (error) {
			toast.error("An error occurred while submitting the form. Please try again.");
		};
		// dispatch(settings.set({ getQuote: 'open' }))

	}
	useEffect(() => {
		if (isLead && leadCreateData?.isSuccess) {


			handleNext();

		}
	}, [isLead])
	// Step 2: Submit Quotes
	const handleSaveQuote = async () => {

		if (
			!productItems?.CategoryName ||
			!productItems?.SubCategoryName ||
			!productItems?.ProductTypeName ||
			!productItems?.VehicleNumber ||
			!productItems?.VehicleYear ||
			!productItems?.VehicleModel ||
			!productItems?.VehicleBrand ||
			!quoteData?.date ||
			!searchedLocation?.description ||
			!dropLocations?.description
		) {
			toast.error("All fields are required. Please fill in all the details.");
			return; // Stop further execution if validation fails
		}
		const fromAddressData = _.split(searchedLocation?.description, ',');
		const toAddressData = _.split(dropLocations?.description, ',');
		const categoryName = categoryListItems?.result?.items.find(
			(item: any) => item.Id == productItems?.CategoryName
		);
		const valueData = {

			MobilityLeadId: leadCreateData?.result[0] || '',
			RAPCustomerId: customerListData?.result?.items[0]?.Id,
			ScheduledDate: quoteData?.date,
			items: [
				{
					CategoryName: productItems?.CategoryName,
					SubCategoryName: productItems?.SubCategoryName || '',
					ProductTypeName: productItems?.ProductTypeName,
					VehicleNumber: productItems?.VehicleNumber,
					VehicleYear: productItems?.VehicleYear,
					VehicleModel: productItems?.VehicleModel,
					VehicleBrand: productItems?.VehicleBrand,
					VehicleChassisNumber: productItems?.VehicleChassisNumber
				}
			],

			fulfillment: {
				category_id: shippingTypesDetails?.result?.items[0]?.Id,
				start: {
					location: {
						gps: `${searchedLocation?.lat} ,${searchedLocation?.lng}`,
						address: {
							name: quoteData?.pickupName,
							building: quoteData?.startBuilding,
							locality: `${fromAddressData[0]},${fromAddressData[1]}`,
							city: searchedLocation?.name,
							state: fromAddressData[3] || 'TamilNadu',
							country: 'India',
							area_code: searchedLocation?.pincode || ''
						}
					},
					contact: {
						phone: quoteData?.pickupPhoneNumber,
						email: leadValues?.Email
					}
				},
				end: {
					location: {
						gps: `${dropLocations?.lat} ,${dropLocations?.lng}`,
						address: {
							name: quoteData?.dropName,
							building: quoteData?.endBuilding,
							locality: `${toAddressData[0]},${toAddressData[1]}`,
							city: dropLocations?.name,
							state: toAddressData[3] || 'TamilNadu',
							country: 'India',
							area_code: dropLocations?.pincode || ''
						}
					},
					contact: {
						phone: quoteData?.dropPhoneNumber,
						email: ''
					}
				}
			}

		}
		dispatch(settings.set({
			valueData
		}))
		if (searchedLocation?.description !== dropLocations?.description) {
			await dispatch(quotes.resetAction({ actionType: 'create' }))
			await dispatch(quotes.create({
				url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/sales/quotes`, entity: 'quotes',
				jsonData:{
					Context:{},
					Records:[
						valueData]
				}
			}))
			await setIsQuotes(true)
			await setIsButtonLoading(false)
		}

		else {
			setIsButtonLoading(false)
			toast.error("The Pickup and Drop addresses must be different.")
		}
	}

	useEffect(() => {

		if (isQuotes && quoteDetails?.isSuccess) {
			setSearchedLocation({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: ''
			})
			setDropLocation({
				name: '',
				lat: '',
				lng: '',
				pincode: '',
				description: ''
			})
			setIsQuotes(false)
			handleNext();
		}
	}, [isQuotes])


	// Step 3: Add Payment
	const handleOrder = async () => {
		await setIsButtonLoading(true)
		await dispatch(addPayment.update({
			url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/check-outs/add-payment`, entity: 'addPayment', jsonData: {

				Records: [{
					Context: {
						transaction_id: generateIds?.transaction_id,
						message_id: generateIds?.message_id,
					},
					Message: {
						Id: quoteDetails?.result?.Records[0]?.MobilityQuoteId,
						OwnerType: 'MobilityQuote',
						PaidAmount: quoteDetails?.result?.Records[0]?.quote?.breakup[0]?.price?.value,
						PaymentRemarks: 'Mobility',
						PaymentMethodId: selected, // Number(sessionStorage.getItem('paymentmethod')),
						PaymentGatewayId: paymentGateway[0]?.Id || 0,
					},
				}

				],
			}
		}))
		await dispatch(orders.resetAction({ actionType: 'create' }))
		await setIsPaymentAdded(true);

	};
	// Step 4: Confirm Logistics Order
	useEffect(() => {
		if (isPaymentAdded) {
			const orderData = {
				"StoreSalesChannelId": salesChannelId,
				"MobilityProductId": result?.quoteData?.mobilityProdcutId,
				"RAPCustomerId": quoteDetails?.result?.Records[0]?.RAPCustomerId || customerListData?.result?.items[0]?.Id,
				"IsUserHasSubscription": quoteDetails?.result?.Records[0]?.IsUserHasSubscription,
				"order": {

					"customer": {
						"id": customerListData?.result?.items[0]?.Id || '',
						"name": customerListData?.result?.items[0]?.RAPCustomerName || '',
						"phone": customerListData?.result?.items[0]?.PhoneNumber || '',
						"email": leadValues?.Email || customerListData?.result?.items[0]?.Email || '',
						"vehicle": {
							"number": quoteDetails?.result?.Records[0]?.items[0]?.VehicleNumber,
							"chasis_number": quoteDetails?.result?.Records[0]?.items[0]?.VehicleChassisNumber,
							"brand": quoteDetails?.result?.Records[0]?.items[0]?.VehicleBrand,
							"model": quoteDetails?.result?.Records[0]?.items[0]?.VehicleModel,
							"year": quoteDetails?.result?.Records[0]?.items[0]?.VehicleYear
						}
					},
					"provider": {

					},
					"service": [
						{
							"id": 0,
							"name": "Asstance",
							"quote": {
								"price": quoteDetails?.result?.Records[0]?.quote?.breakup[0]?.price?.value,
								"ScheduledDate": quoteData?.date,
								"breakup": [
									{
										"id": 0,
										"title": "Assitance",
										"price": quoteDetails?.result?.Records[0]?.quote?.breakup[0]?.price?.value
									}
								]
							}
						}
					],
					"fulfillments": [
						{
							"start": {
								"customer": {
									"id": customerListData?.result?.items[0]?.Id || '',
									"name": result?.valueData?.fulfillment?.start?.location?.address?.name,
									"phone": result?.valueData?.fulfillment?.start?.contact?.phone,
									"email": result?.valueData?.fulfillment?.start?.contact?.email,
									"vehicle": {
										"number": result?.valueData?.items[0]?.VehicleNumber,
										"chasis_number": result?.valueData?.items[0]?.VehicleChassisNumber,
										"brand": result?.valueData?.items[0]?.VehicleBrand,
										"model": result?.valueData?.items[0]?.VehicleModel,
										"year": result?.valueData?.items[0]?.VehicleYear
									}
								},
								"person": {
									"name": result?.valueData?.fulfillment?.start?.location?.address?.name
								},
								"location": {
									"gps": result?.valueData?.fulfillment?.start?.location?.gps,
									"address": {
										"name": result?.valueData?.fulfillment?.start?.location?.address?.name,
										"building": result?.valueData?.fulfillment?.start?.location?.address?.building,
										"locality": result?.valueData?.fulfillment?.start?.location?.address?.locality,
										"city": result?.valueData?.fulfillment?.start?.location?.address?.city,
										"state": result?.valueData?.fulfillment?.start?.location?.address?.state,
										"country": result?.valueData?.fulfillment?.start?.location?.address?.country,
										"area_code": result?.valueData?.fulfillment?.start?.location?.address?.area_code
									}
								},
								"contact": {
									"phone": result?.valueData?.fulfillment?.start?.contact?.phone,
									"email": result?.valueData?.fulfillment?.start?.contact?.email
								},
								"instructions": {
									"short_desc": "string",
									"long_desc": "string",
									"images": [
										"string"
									]
								}
							},
							"end": {
								"customer": {
									"id": customerListData?.result?.items[0]?.Id || '',
									"name": result?.valueData?.fulfillment?.end?.location?.address?.name,
									"phone": result?.valueData?.fulfillment?.end?.contact?.phone,
									"email": result?.valueData?.fulfillment?.start?.contact?.email,
									"vehicle": {
										"number": result?.valueData?.items[0]?.VehicleNumber,
										"chasis_number": result?.valueData?.items[0]?.VehicleChassisNumber,
										"brand": result?.valueData?.items[0]?.VehicleBrand,
										"model": result?.valueData?.items[0]?.VehicleModel,
										"year": result?.valueData?.items[0]?.VehicleYear
									}
								},
								"person": {
									"name": result?.valueData?.fulfillment?.end?.location?.address?.name,
								},
								"location": {
									"gps": result?.valueData?.fulfillment?.end?.location?.gps,
									"address": {
										"name": result?.valueData?.fulfillment?.end?.location?.address?.name,
										"building": result?.valueData?.fulfillment?.end?.location?.address?.building,
										"locality": result?.valueData?.fulfillment?.end?.location?.address?.locality,
										"city": result?.valueData?.fulfillment?.end?.location?.address?.city,
										"state": result?.valueData?.fulfillment?.end?.location?.address?.state,
										"country": result?.valueData?.fulfillment?.end?.location?.address?.country,
										"area_code": result?.valueData?.fulfillment?.end?.location?.address?.area_code
									}
								},
								"contact": {
									"phone": result?.valueData?.fulfillment?.end?.contact?.phone,
									"email": result?.valueData?.fulfillment?.end?.contact?.email
								},
								"instructions": {
									"short_desc": "string",
									"long_desc": "string",
									"images": [
										"string"
									]
								}
							}
						}
					],
				},
				"job": {

				},
				"feedback": {

				}
			}

			dispatch(orders.create({
				url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/sales/orders/confirm`,
				entity: 'orderCreate',
				jsonData: orderData
			})).then(() => {
				setIsButtonLoading(false)
				setIsOrderPlaced(true);
			}).then(() => {
				setSearchedLocation({
					name: '',
					lat: '',
					lng: '',
					pincode: '',
					description: ''
				})
				setDropLocation({
					name: '',
					lat: '',
					lng: '',
					pincode: '',
					description: ''
				})

			})
		}
	}, [isPaymentAdded])
	const encrypt1 = (plainText: string, workingKey: string): string => {
		// Create an MD5 hash of the workingKey
		const key = CryptoJS.MD5(workingKey).toString(CryptoJS.enc.Hex);

		// Initialization vector (IV)
		const iv = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

		// Encrypt the plainText
		const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Hex.parse(key), {
			iv: iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		// Return the encrypted text in hex format
		return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
	};
	const handeCCAvenuePayment = (orderDetails: any) => {
		const workingKey =
			razorpaySettings.CCAvenue?.WorkingKey; //Put in the 32-Bit key shared by CCAvenues.
		const accessCode =
			razorpaySettings.CCAvenue?.AccessCode;
		const merchantId =
			razorpaySettings.CCAvenue?.MerchantId;

		const companyName = localStorage.getItem("CompanyName");
		const channel = storePersist.get("channels").current.find((element: any) => element.SalesChannelName === "CSP");
		const tenant = companyName; //getBusinessCompanyName();
		const ChannelId = channel.Id //getSalesChannelId();

		// const guestTokenData = {
		// 	Channel: channel.SalesChannelName, //SalesChannelName(),
		// 	Requester: `https://${tenant}.csp.digiit.${process.env.REACT_APP_API_URL}/`,
		// 	StoreId: storeId,
		// 	SalesChannelId: ChannelId,
		// };
		// const accessTokenData = {
		// 	PhoneNumber: userInfo[0]?.PhoneNumber,
		// 	TenantName: tenant,
		// 	SalesChannelId: ChannelId,
		// };
		const ccAvenueData = {
			merchant_id: merchantId,
			order_id: orderDetails?.order?.id,
			currency: 'INR',
			amount: Number(orderDetails?.order?.quote?.price?.value), //Total Price,
			// redirect_url: `https://payments.digiit.ai/${tenant}/${storeId}/${ChannelId}/ccavResponseHandler`,
			// cancel_url: `https://payments.digiit.ai/${tenant}/${storeId}/${ChannelId}/ccavResponseHandler`,
			redirect_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channel?.Id}/${orderDetails?.order?.billing?.phone}/ccavResponseHandler`,
			cancel_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channel?.Id}/${orderDetails?.order?.billing?.phone}/ccavResponseHandler`,
			language: 'EN',
			billing_name: orderDetails?.order?.billing?.name,
			billing_address: orderDetails?.order?.billing?.address?.name,
			billing_city: orderDetails?.order?.billing?.address?.city,
			billing_state: orderDetails?.order?.billing?.address?.state,
			billing_zip: orderDetails?.order?.billing?.address?.area_code,
			billing_country: orderDetails?.order?.billing?.address?.country,
			billing_tel: orderDetails?.order?.billing?.phone,
			billing_email: orderDetails?.order?.billing?.email,
			delivery_name: orderDetails?.order?.fulfillments[0]?.end?.person?.name,
			delivery_address: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.name,
			delivery_city: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.city,
			delivery_state: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.state,
			delivery_zip: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.area_code,
			delivery_country: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.country,
			merchant_param1: tenant, //getOrganizationName(),
			merchant_param2: tenantId,
			merchant_param3: `${window.location.hostname}`,
			merchant_param4: '',
			merchant_param5: '',
			integration_type: 'iframe_normal',
			// promo_code:'PROMO8513',
			customer_identifier: '',
		};
		const body = queryString.stringify(ccAvenueData);
		//console.log('body', body)
		const encRequest1 = encrypt1(body, workingKey);
		// let URL = `https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
		let URL = `https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
		//console.log('URL', URL)
		window.location.href = URL;
		// router.push(URL);
	}
	useEffect(() => {
		if (isOrderPlaced) {
			switch (selected) {
				case 10: //cash payment
					handleClose()
					break;
				case 20: //online
					switch (paymentGateway[0]?.Id) {
						case 10: //razorpay
							// handeRazorpay()
							break;
						case 20: //ccavenue
							handeCCAvenuePayment(orderDetails?.result?.items?.Records[0]?.message)
							break;
						case 30: //phonepe
							break;
						default:
					}


					break;
				case 30: //wallet
					break;
			}

		}
	}, [isOrderPlaced])

	useEffect(() => {

		generateIdValue()
		dispatch(productTypes.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/product-types/list`, entity: 'productTypes', jsonData: {} }))
			.then(() => {
				dispatch(shippingTypes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {} }))
			}).then(() => {
				dispatch(categories.list({
					url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/categories/list`,
					entity: 'categories',
					jsonData: {}
				}));
			}).then(() => {
				dispatch(paymentMethods.query({
					url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods/query-by-tenants`, entity: 'paymentMethods', jsonData:
						{ "Tenants": [{ "Id": tenantId }] }
				}))
			}).then(() => {
				dispatch(channel.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/organization-management/channels/list`, entity: 'channels', jsonData: {} }))
			})
		dispatch(products.list({ url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/taxonomy/products/list`, entity: 'products', jsonData: {} }))
		//}
	}, []);
	return (
		<>
			{getQuote == 'open' ? (
				<>
					<div className="absolute fixed w-[900px] mt-10 inset-0  z-50 flex flex-warp justify-center align-middle">
						<div className=" my-2 mx-auto max-w-sm">
							<div className={`rounded-lg shadow-lg flex flex-col w-[900px] bg-slate-50 h-auto p-5 overflow-auto bg-scroll`}>
								<div className="flex items-start justify-between w-full border-b p-2 ">
									<div className="flex w-full flex-col items-start justify-between text-xl" >
										Request a Quote  (Step {`${tutorialSteps[activeStep].id}/${maxSteps}`}) - {tutorialSteps[activeStep].title}
									</div>
									<div className="cursor-pointer mx-1">
										<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x-circle"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
									</div>
								</div>
								<div className="w-full flex flex-row p-3 border-b p-2 -500 py-5">
									<div className="w-1/4">
										{tutorialSteps[activeStep].title}
									</div>
									<div className="flex flex-col w-3/4 space-y-3">
										{tutorialSteps[activeStep].component}
									</div>
								</div>

								<div className="w-full flex flex-row p-3 ">

									{tutorialSteps[activeStep].id === maxSteps ? (
										<div className="w-full">
											<div className="flex flex-row justify-end items-center space-x-2">
												<button disabled={activeStep === 1} onClick={handleBack} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold`}>
													Back
												</button>
												<button onClick={handleClose} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold`}>
													Book Later
												</button>
												<button onClick={handleOrder} disabled={isButtonLoading} className={`${isButtonLoading ? 'bg-primary bg-opacity-70 w-44 ' : 'bg-primary '}  text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold `}>
													Confirm Booking
													{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
														<RotatingLines
															visible={true}
															width={'20'}
															strokeColor="#fff"
															strokeWidth="6"
															animationDuration="0.75"
															ariaLabel="rotating-lines-loading"
														/>
													</div>}
												</button>
											</div>
										</div>) : (
										<>
											<div className="w-full">

												<div className="flex flex-row justify-end items-center space-x-2">
													{activeStep !== 0 && (<button onClick={handleBack} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold`}>
														Back											</button>)}
													{tutorialSteps[activeStep].id === 1 && (<button onClick={handleSubmit} disabled={isButtonLoading && activeStep === maxSteps - 1} className={`${isButtonLoading ? 'bg-primary bg-opacity-70 w-20 ' : 'bg-primary '}  text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold `}>
														Next
														{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
															<RotatingLines
																visible={true}
																width={'20'}
																strokeColor="#fff"
																strokeWidth="6"
																animationDuration="0.75"
																ariaLabel="rotating-lines-loading"
															/>
														</div>}
													</button>)}
													{tutorialSteps[activeStep].id !== 1 && tutorialSteps[activeStep].id !== 4 && (<button onClick={handleNext} disabled={activeStep === maxSteps - 1} className={`bg-primary text-light border-x border-y  px-2 py-1 text-sm font-bold`}>
														Next
													</button>)}
													{tutorialSteps[activeStep].id === 4 && (<button onClick={handleSaveQuote} disabled={activeStep === maxSteps - 1} className={`${isButtonLoading ? 'bg-primary bg-opacity-70 w-20 ' : 'bg-primary '}  text-light items-center justify-center flex flex-row   border-x border-y  px-2 py-1 text-sm font-bold `}>
														Next
														{isButtonLoading && <div className={`${isButtonLoading ? 'visible' : 'invisible'}`}>
															<RotatingLines
																visible={true}
																width={'20'}
																strokeColor="#fff"
																strokeWidth="6"
																animationDuration="0.75"
																ariaLabel="rotating-lines-loading"
															/>
														</div>}
													</button>)}

												</div>
											</div>
										</>
									)}

								</div>
							</div>
						</div>
					</div>
				</>
			) : null
			}
		</>
	);
}
